































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import {
  CampaignStatistics,
  CampaignSettings
} from '@/components/organisms/Referral/DataPresentation';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';

import { IBusinessReferralChart } from '@/models/marketingCenter/referral';
import ReferralService from '@/api/ReferralService';

@Component({
  components: {
    Surface,
    Typography,
    CampaignStatistics,
    CampaignSettings,
    GhostButton,
    ArrowRightInfoIcon
  }
})
export default class CampaignListItem extends Vue {
  @Prop() readonly item: any;

  referralService = new ReferralService();
  chart: IBusinessReferralChart = {};

  goToReferralDetail() {
    this.$router.push('/referral-program');
  }

  async getChart() {
    if (!this.item.id) return;

    const { data } = await this.referralService.getChart(this.item.id);
    this.chart = data;
  }

  async created() {
    await this.getChart();
  }
}
